import { Accordion, Flex, For, Grid, GridItem, Heading, Image } from "@chakra-ui/react"
import { FaCirclePlus } from "react-icons/fa6";
import './styles/FAQComponent.css';

function FAQComponent(props: any) {

  let questions = [
    {
      "question": "Will negotiating lead to my offer being rescinded?",
      "answer": "We never say never. Anything can happen during the course of a negotiations process. However, we have never had a company rescind their offer during one of our negotiations and estimate the probability to be very very low."
    },
    {
      "question": "What's the best time to reach out to an expert?",
      "answer": "We recommend engaging with an expert as soon as possible. The negotiation process can actually start as early as the first initial recruiter reach out. It's easy to say the wrong thing early on and therefore lower the chances of a successful outcome. That's why we recommend reaching out as soon as possible. However, conversely it's also never too late to reach.",
    },
    {
      "question": "What happens if we don't negotiate any increase?",
      "answer": "We believe this partnership should be a mutual partnership. We only get paid if you do too. If we can't help you negotiate any sort of increase (unlikely), then there is no charge.",
    },
    {
      "question": "How are you different from other negotiating services?",
      "answer": "We're interested in really teaching you how to negotiate instead of just a one off business transaction. We want to enable you to confidently negotiate for yourself in the future. Ideally you will never have to use our service again, and we mean that!",
    },
    {
      "question": "Can you help negotiate non-monetary benefits?",
      "answer": "Absolutely! A lot of people don't realize that you can negotiate 'soft' benefits. We can help negotiate stuff like PTO, vacation days, garden leave, WFH, etc., although we don't guarantee any results."
    }
  ];

  return (
    // Need to use this trick so we jump to the offset of navigation bar
    <div style={{
        paddingTop: '69px',
        marginTop: '-69px',
    }}
    id='faq'>
        {/* Desktop only view */}
        <Flex className="faq_component__parent" direction='column' gap='8'>
            <Heading color='black' size='2xl' style={{marginBottom: '40px'}}>
                Frequently Asked Questions
            </Heading>
            <For each={questions}>
              {(item, index) => (
                <Accordion.Root backgroundColor='white' border='none' borderRadius='12px' variant='plain' multiple padding='20px 25px 20px 25px' style={{marginBottom: '25px'}}>
                  <Accordion.Item value="Will">
                    <Accordion.ItemTrigger color='black' fontWeight='bold' fontSize='lg' justifyContent='space-between'>
                        {item.question}
                      <Accordion.ItemIndicator className='hover' color='#FB5383' style={{cursor: "pointer"}}>
                        <FaCirclePlus className='hover'/>
                      </Accordion.ItemIndicator>
                    </Accordion.ItemTrigger>
                    <Accordion.ItemContent>
                      <Accordion.ItemBody color='black' textAlign='left' fontSize='md'>
                        {item.answer}
                      </Accordion.ItemBody>
                    </Accordion.ItemContent>
                  </Accordion.Item>
                </Accordion.Root>
              )}
            </For>
        </Flex>

        {/* Mobile only view */}
        <Flex className="faq_component__mobile_parent" direction='column' gap='8'>
            <Heading color='black' size='2xl' style={{marginBottom: '25px'}}>
                Frequently Asked Questions
            </Heading>
            <For each={questions} >
              {(item, index) => (
                <Accordion.Root backgroundColor='white' border='none' borderRadius='12px' variant='plain' multiple padding='15px 20px 15px 20px' style={{marginBottom: '20px'}}>
                  <Accordion.Item value="Will">
                    <Accordion.ItemTrigger color='black' fontWeight='bold' fontSize='lg' justifyContent='space-between'>
                        {item.question}
                      <Accordion.ItemIndicator className='hover' color='#FB5383' style={{cursor: "pointer"}}>
                        <FaCirclePlus className='hover'/>
                      </Accordion.ItemIndicator>
                    </Accordion.ItemTrigger>
                    <Accordion.ItemContent>
                      <Accordion.ItemBody color='black' textAlign='left' fontSize='md'>
                        {item.answer}
                      </Accordion.ItemBody>
                    </Accordion.ItemContent>
                  </Accordion.Item>
                </Accordion.Root>
              )}
            </For>
        </Flex>
    </div>

  );
}

export default FAQComponent;
